<template>
  <base-modal ref="base-modal" pageId="modal_test" pageClass="test" modalClass="modal-md" modalDataBack="true" modalDataKey="true"> <!-- :key="keyModal" -->

    <template #header>
      <h4 class="modal-title" id="pge_eval_title">Titre</h4>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </template>

    <template #body>
      <div class="text-left my-3" style="font-size: 1.2em;">
        <p class="">Texte</p>
      </div>
    </template>

    <template #footer>
      <div class="btn-group bnt-block w-100">
        <button class="btn btn-secondary btn-md" data-dismiss="modal" style="width:40%;">
          <span class="oi oi-ban mr-2"></span>
          Annuler
        </button>
      </div>
    </template>

  </base-modal>
</template>

<script>
import BaseModal from '@/components/BaseModal'

export default {
  props: {
    pass: String,
    zkp: String,
  },
  components: {
    BaseModal,
  },
  data() {
    return {
      passEval: '',
      keyModal: false,
    }
  },
  methods: {
   save() {
      var sPassEval = this.passEval;
      this.passEval = '';
      // $('#modal_eval_' + this.zkp).modal('hide');
      $('#modal_test').modal('hide');
      this.$emit('save', sPassEval);
    },
  },
}
</script>

<style scoped>
  /* void */
</style>



// WEBPACK FOOTER //
// src/components/misc/ModalTest.vue